export const enum PS_EVENTS {
	AUTO_SCROLL = 'AUTO_SCROLL',
	INPUT_FOCUS = 'INPUT_FOCUS',
}
